/**
 * Public / Private selector for Files & Links items (files + external links).
 *
 * Shared by the Files & Links page upload/link dialogs AND the Space "Files"
 * tab, so both surfaces offer the SAME choice and copy — a file or link
 * uploaded inside a Space can be made Private exactly as on the main page.
 *
 * `privateNote` overrides the default "Only you … can see this X." hint. It is
 * needed because that default is FALSE for a LINK — a private link is
 * creator-only with NO admin override — whereas a private FILE is visible to
 * the owner AND a governance admin (Company Admin / Sub Admin). Pass the
 * link-specific note on link surfaces.
 */
export default function VisibilityPills({
  value,
  onChange,
  kind = 'file',
  privateNote,
}) {
  return (
    <div>
      <label className="block text-xs uppercase tracking-wider font-semibold text-[color:var(--color-ink-muted)] mb-1">
        Visibility
      </label>
      <div className="inline-flex rounded-md border border-[color:var(--color-rule)] bg-[color:var(--color-canvas)] p-0.5">
        {[
          { value: 'public', label: 'Public' },
          { value: 'private', label: 'Private' },
        ].map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={
              'px-3 py-1.5 rounded text-xs font-medium cursor-pointer transition-colors ' +
              (value === opt.value
                ? 'bg-[color:var(--color-card)] text-[color:var(--color-ink-strong)] shadow-sm'
                : 'text-[color:var(--color-ink-muted)] hover:text-[color:var(--color-ink)]')
            }
          >
            {opt.label}
          </button>
        ))}
      </div>
      <p className="mt-1 text-xs text-[color:var(--color-ink-muted)]">
        {value === 'private'
          ? (privateNote ??
            `Only you and your Company Admin or Sub Admin can see this ${kind}.`)
          : `Anyone who can access its Space — your department, plus company-wide members and admins — can see this ${kind}.`}
      </p>
    </div>
  )
}
